import React from 'react';

import useCreditDataCard from '@/features/credit/hooks/useCreditDataCard';
import { rootSelectors } from '@/features/store';
import { withHiddenLazyComponent } from '@/hoc';

import { CreditDataCardProps } from './CreditDataCard.types';

function CreditDataCard(props: CreditDataCardProps) {
  useCreditDataCard(props);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

export default withHiddenLazyComponent(
  CreditDataCard,
  rootSelectors.config.creditEnableSelector,
);
